import React from "react";
import { Button, buttonVariants } from "../ui/button";

interface Props {
  slotInfo: string;
  onCancelClick: () => void;
  onRescheduleClick: () => void;
}

const AppointmentTimeBox: React.FC<Props> = ({
  slotInfo,
  onCancelClick,
  onRescheduleClick,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="flex flex-col sm:flex-row justify-between">
        <div>
          <h3 className="font-bold text-base mb-1">Appointment Time</h3>
          <p className="text-sm font-bold text-primary">{slotInfo}</p>
        </div>

        <div className="flex gap-3 mt-3 sm:mt-0">
          <Button
            onClick={onCancelClick}
            className={buttonVariants({
              variant: "outline",
              className: "text-teal-700 font-semibold px-3 shadow",
            })}
          >
            Cancel appointment
          </Button>

          <Button
            onClick={onRescheduleClick}
            className={buttonVariants({
              variant: "outline",
              className: "text-teal-700 border-teal-700 font-bold px-3 shadow",
            })}
          >
            Reschedule
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AppointmentTimeBox;
